import { Skeleton, Typography } from '@mui/material';
import {
  isCon,
  isPro,
  JudgmentCounts,
  judgmentCountsConCss,
  judgmentCountsNeutralCss,
  judgmentCountsProCss
} from 'features/fact-grabbing/useReferencesByClaim';
import FormattedMessage from 'features/i18n/FormattedMessage';
import styled from 'styled-components';

type Props = {
  judgmentCounts: JudgmentCounts;
  isLoading: boolean;
  isError: boolean;
};

export const ClaimReferencesStatusText = ({ isError, isLoading, judgmentCounts }: Props) => {
  if (isLoading || isError) {
    return <Skeleton variant="rounded" width={120} height={24} />;
  }

  if (isPro(judgmentCounts)) {
    return (
      <ProStatusText variant="caption">
        <FormattedMessage id="aiWriter.inspirations.factGrabbing.claim.judgment_label.pro" />
      </ProStatusText>
    );
  }

  if (isCon(judgmentCounts)) {
    return (
      <ConStatusText variant="caption">
        <FormattedMessage id="aiWriter.inspirations.factGrabbing.claim.judgment_label.con" />
      </ConStatusText>
    );
  }

  return (
    <NeutralStatusText variant="caption">
      <FormattedMessage id="aiWriter.inspirations.factGrabbing.claim.judgment_label.neutral" />
    </NeutralStatusText>
  );
};

const ProStatusText = styled(Typography)`
  ${judgmentCountsProCss};
`;

const ConStatusText = styled(Typography)`
  ${judgmentCountsConCss};
`;

const NeutralStatusText = styled(Typography)`
  ${judgmentCountsNeutralCss};
`;
